import { RelatedEntity } from "./relatedEntity.types";

/** The record with one related table's rows replaced, or added if it had none. */
export function withRelatedRecords(
  previous: Record<string, unknown> | null,
  relatedEntityName: string,
  records: RelatedEntity["entities"]
) {
  if (!previous) {
    return previous;
  }

  const current = (previous.relatedEntities ?? []) as RelatedEntity[];
  const found = current.some(
    (related) => related.entityName === relatedEntityName
  );

  return {
    ...previous,
    relatedEntities: found
      ? current.map((related) =>
          related.entityName === relatedEntityName
            ? // Fresh rows mean the table was read, whatever the last read did.
              { ...related, entities: records, failed: false }
            : related
        )
      : [...current, { entityName: relatedEntityName, entities: records }],
  };
}
